import './style.css.js';
import React, { Children, useMemo } from 'react';
import { GroupListItem } from './group-list-item.js';
import { OverflowDropdown } from './overflow-dropdown.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const TagGroupWithOverflow = /* @__PURE__ */ __name(({
  children,
  overflow,
  overflowClassName,
  selectable,
  size
}) => {
  const childArray = Children.toArray(children);
  const wrappedChildren = useMemo(
    () => childArray.map((child) => /* @__PURE__ */ React.createElement(GroupListItem, {
      key: Math.random()
    }, child)),
    [childArray]
  );
  const childrenToShow = wrappedChildren.slice(0, overflow);
  const childrenToHide = childArray.slice(overflow);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, childrenToShow, childrenToHide && /* @__PURE__ */ React.createElement(OverflowDropdown, {
    hidden: childrenToHide,
    overflowClassName,
    selectable: Boolean(selectable),
    size
  }));
}, "TagGroupWithOverflow");

export { TagGroupWithOverflow };
//# sourceMappingURL=group-with-overflow.js.map
